// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#stat-row[data-v-85e85c32] {\n  position: absolute;\n  top: -58px;\n  left: -20px;\n  transform: skew(0.65rad);\n  background-color: var(--v-panel-base);\n  color: var(--v-text-base);\n  z-index: 2;\n  width: 70vw;\n  margin-left: -20px;\n}\n.unskew[data-v-85e85c32] {\n  transform: skew(-0.65rad);\n}\n", ""]);
// Exports
module.exports = exports;
